import React from 'react';
import { Twitter, Linkedin, Facebook, Instagram, Sun, Moon, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { HeaderProps } from '../types/components';

const Header: React.FC<HeaderProps> = ({ isDark, toggleTheme, language, toggleLanguage, texts }) => {
  return (
    <header className="sticky top-0 w-full bg-white/80 dark:bg-[#1a1a1a]/80 backdrop-blur-sm z-50 border-b border-gray-200 dark:border-gray-800 transition-colors duration-200">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold">
          <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {/* You can add your logo or site name here */}
          </Link>
        </h1>

        <nav className="flex space-x-6">
          {/* Replace <a> with <Link> for internal navigation */}
          <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {texts.header.home}
          </Link>
          <Link to="/about" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {texts.header.about}
          </Link>
          <Link to="/blog" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {texts.header.blog}
          </Link>
          <Link to="/projects" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {texts.header.projects}
          </Link>
          <Link to="/contact" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            {texts.header.contact}
          </Link>
        </nav>

        <div className="flex items-center space-x-4">
          <Twitter className="hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
          <a href="https://www.linkedin.com/in/anton-joncour-colombel-a43408346/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <Linkedin className="hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
          </a>
          <Facebook className="hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
          <Instagram className="hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
          <button onClick={toggleTheme} className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" aria-label="Toggle theme">
            {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </button>
          <button onClick={toggleLanguage} className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" aria-label="Toggle language">
            <Globe className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
